import { Account } from '../../../server/services/accounts/account.contractparts';
import { AccountsGetRequest } from '../../../server/services/accounts/get.contract';
import { CurrentApplication } from '../pages/application/current-application';
import { globalState } from './state';
import { AppConfig } from './config';
import { ApplicationQueryRequest } from '../../../server/services/application/query.contract';
import { CoreSettingsGetRequest } from '../../../server/services/core/settings/get.contract';

export class Session {
  static account?: Account;
  static beforeLoginUrl: string;

  static tmp: SessionTmpValues = {};

  private static _token?: string;
  static get token(): string | undefined {
    return this._token ?? (this._token = (localStorage.getItem('token') ?? undefined) as string);
  }

  static set token(value: string) {
    if (value === undefined || value === null) {
      this._token = undefined;
      localStorage.removeItem('token');
    } else {
      this._token = value;
      localStorage.setItem('token', value);
    }
    this.setTokenCookie();
  }

  private static _testSystemToken: string;
  static get testSystemToken(): string | undefined {
    return this._testSystemToken ?? (this._testSystemToken = (localStorage.getItem('testSystemToken') ?? undefined) as string);
  }

  static set testSystemToken(value: string) {
    if (value === undefined || value === null) {
      this._testSystemToken = undefined;
      localStorage.removeItem('testSystemToken');
    } else {
      this._testSystemToken = value;
      localStorage.setItem('testSystemToken', value);
    }
  }

  static setTokenCookie(): void {
    let token: string;
    if (AppConfig.isTestSystem() && Session.testSystemToken) {
      token = (this.testSystemToken ?? '') + (this.token ?? '');
    } else {
      token = this.token;
    }
    if (!this.token) { // delete cookie
      document.cookie = "token=; Path=/; Max-Age=0; SameSite=Lax; Secure";
    } else {
      document.cookie = `token=${token}; Path=/; SameSite=Lax; Secure`;
    }
  }

  static async init() {
    if (this.token) {
      this.setTokenCookie();
      this.account = await new AccountsGetRequest().execute();
      if (!this.account) {
        return
      }
      globalState.isLoggedIn = true;
      if (Session.account?.hasRole('applicant')) {
        globalState.applications = globalState.daysLeftTillStart > 0 && !this.account.hasRole('earlyAccess')
          ? []
          : (await new ApplicationQueryRequest().execute()) ?? [];
        if (globalState.applications.length) {
          await CurrentApplication.load(globalState.applications[0]);
          return false;
        } else {
          await CurrentApplication.create();
        }
      } else {
        CurrentApplication.initializedPromise.resolve();
      }
      globalState.settings = await new CoreSettingsGetRequest().execute();
    }
  }

  static abandon() {
    if (this.token) {
      CurrentApplication.reset()
      this.token = undefined;
      this.account = null;
      globalState.isLoggedIn = false;
      document.location.href = '/login';
    }
  }
}

export interface SessionTmpValues {
  faqSearchString?: string
}
